module.exports = __webpack_public_path__ + "static/subpages-affordability-header.daa7a9d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/desktop/subpages-affordability-header.jpg
// module id = 588
// module chunks = 126523225082832